﻿﻿﻿<customeritem-filter (outputFilter)="onFilter($event)"></customeritem-filter>
<customeritem-list [list]="list" [showLocalFilter] ="showLocalFilter"></customeritem-list>